import { render, staticRenderFns } from "./DefaultBreadcrumbs.vue?vue&type=template&id=6a51be0e&scoped=true&"
import script from "./DefaultBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./DefaultBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./DefaultBreadcrumbs.vue?vue&type=style&index=0&id=6a51be0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a51be0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VRow,VToolbar})
